const convertToUrl = (text) => {
  if (!text) return "";
  const regex = /(ö|ç|ş|ı|ğ|ü)/g;
  const characters = {
    ö: "o",
    ç: "c",
    ş: "s",
    ı: "i",
    ğ: "g",
    ü: "u",
  };

  text = text.toLocaleLowerCase("tr-TR");

  if (regex.test(text)) {
    text = text.replace(regex, (m, key) => characters[key]);
  }

  /* remove the special char */
  text = text.replace(/[^A-Z0-9]+/gi, "-");

  /* space to '-' */
  text = text.replace(/[\s-]+/g, "-");

  return text;
};

module.exports = convertToUrl;
